import PropTypes from "prop-types";

import { FlexContainers, Heading3, Paragraph2, WrapperContainer } from "../../components";
import { LoginPageContainer, ChildrenWrapper } from "./styled";

const LoginPageTemplate = ({ icon, title, description, children }) => {
  return (
    <LoginPageContainer>
      <WrapperContainer Container={FlexContainers.FlexColumn}>{icon && icon}</WrapperContainer>

      {title && <Heading3>{title}</Heading3>}

      {description && (
        <WrapperContainer mt={18} mb={32} width={"100%"}>
          <Paragraph2>{description}</Paragraph2>
        </WrapperContainer>
      )}

      <ChildrenWrapper>{children}</ChildrenWrapper>
    </LoginPageContainer>
  );
};

LoginPageTemplate.propTypes = {
  icon: PropTypes.node,
  title: PropTypes.string,
  description: PropTypes.string,
  children: PropTypes.node.isRequired
};

export default LoginPageTemplate;
